import React from 'react';
import { Layer, Source } from 'react-map-gl';

// NEXRAD composite reflectivity (Iowa Environmental Mesonet), same source as the old BASE_MAP_STYLE.
// Rendered declaratively so react-map-gl re-adds it after style/theme changes without duplicates.
export const NEXRAD_TILE_URL =
  'https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-900913/{z}/{x}/{y}.png';

export default function NexradOverlay({ opacity = 0.6 }: { opacity?: number }) {
  return (
    <Source id="nexrad" type="raster" tiles={[NEXRAD_TILE_URL]} tileSize={256} attribution="&copy; NOAA/NWS, IEM">
      <Layer id="nexrad-overlay" type="raster" paint={{ 'raster-opacity': opacity }} />
    </Source>
  );
}
